// Tyro integrated receipts (tyro-payment-integration, phase 2).
//
// Tyro returns ready-to-print receipt text (card details already masked by Tyro) on the
// terminal Pay Request; the server stores it on the order and the terminal status call
// returns it as `receipts: { customer, merchant, signature }`. This prints one of them in
// a minimal monospace window. The text is escaped, never injected as HTML.

export const TYRO_RECEIPT_LABELS = {
  customer: 'Print customer receipt',
  merchant: 'Print merchant copy',
  signature: 'Print signature copy',
};

export function escapeReceiptText(text) {
  return String(text == null ? '' : text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function availableTyroReceipts(receipts) {
  if (!receipts || typeof receipts !== 'object') return [];
  return ['customer', 'merchant', 'signature'].filter(
    (k) => typeof receipts[k] === 'string' && receipts[k].trim() !== '',
  );
}

export function tyroReceiptHtml(text, title) {
  return `<!doctype html><html><head><meta charset="utf-8"><title>${escapeReceiptText(title)}</title>`
    + '<style>body{margin:0;padding:12px}pre{font-family:monospace;font-size:12px;white-space:pre-wrap}</style>'
    + `</head><body><pre>${escapeReceiptText(text)}</pre></body></html>`;
}

export function printTyroReceipt(text, title = 'Tyro receipt', win = typeof window !== 'undefined' ? window : null) {
  if (!win || !text) return false;
  const w = win.open('', '_blank', 'width=420,height=640');
  if (!w) return false;
  w.document.open();
  w.document.write(tyroReceiptHtml(text, title));
  w.document.close();
  w.focus();
  w.print();
  return true;
}
